<script>
    export default {
        computed:{
            searchData() {return this.$store.getters.USER_SEARCH_DATA},
            roles() {return this.$store.getters.ROLES},
        },
        methods: {
            async changeField(event, fieldName) {
                this.$store.commit('USER_SEARCH_UPDATE', {
                    fieldName: fieldName, 
                    fieldValue: event.target.value,
                });
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>ID:</label>
        <input
            :value="searchData['id']"
            @change="changeField($event, 'id')"
            class="right_input mt_5 mb_10" 
            type="number"
        >
        <label>Email:</label>
        <input
            :value="searchData['email']"
            @change="changeField($event, 'email')"
            class="right_input mt_5 mb_10" 
            type="email"
        >
        <label>Status:</label>
        <select
            :value="searchData['is_active']"
            @change="changeField($event, 'is_active')"
            class="right_input mt_5 mb_10"
        >
            <option value="all">All</option>
            <option :value="true">Active</option>
            <option :value="false">Disable</option>
        </select>
        <label>Role:</label>
        <select
            :value="searchData['user_role_id']"
            @change="changeField($event, 'user_role_id')"
            class="right_input mt_5"
        >
            <option value="all">All</option>
            <option
                v-for="(roleValue, roleIndex) in roles" :key="roleIndex"
                :value="roleValue['id']"
            >
                {{ roleValue['name'] }}
            </option>
        </select>
    </div>
</template>